"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CategoryList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var classnames_1 = __importDefault(require("classnames"));
var react_1 = require("react");
var react_i18next_1 = require("react-i18next");
var CategoryList = function (_a) {
    var categoryRefs = _a.categoryRefs, categories = _a.categories;
    var t = (0, react_i18next_1.useTranslation)().t;
    var _b = (0, react_1.useState)(0), selectedCategory = _b[0], setSelectedCategory = _b[1];
    var setCategory = function (categoryId, i) {
        setSelectedCategory(categoryId);
        var element = categoryRefs.current[i];
        var yOffset = -120;
        var offsetPosition = element.getBoundingClientRect().top + window.pageYOffset + yOffset;
        window.scrollTo({
            top: offsetPosition,
            behavior: 'smooth',
        });
    };
    (0, react_1.useEffect)(function () {
        if (categories) {
            categoryRefs.current = categoryRefs.current.slice(0, categories.length);
        }
    }, [categories]);
    return ((0, jsx_runtime_1.jsxs)("ul", __assign({ className: 'catalog-list' }, { children: [(0, jsx_runtime_1.jsx)("li", __assign({ onClick: function () { return setSelectedCategory(0); }, className: (0, classnames_1.default)('catalog-item', {
                    'catalog-item-active': selectedCategory === 0,
                }) }, { children: t('All') })), categories === null || categories === void 0 ? void 0 : categories.map(function (category, i) {
                return ((0, jsx_runtime_1.jsx)("li", __assign({ onClick: function () { return setCategory(category.id, i); }, className: (0, classnames_1.default)('catalog-item', {
                        'catalog-item-active': selectedCategory === category.id,
                    }) }, { children: category.name }), category.id));
            })] })));
};
exports.CategoryList = CategoryList;
